var _excluded = ["resize", "maxLength"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { TextArea as TextAreaSemantic } from 'semantic-ui-react';
import { Label, Ref, Segment } from "../..";

/**
  * A TextAreaCounter can be used to allow for extended user TextArea.
  *
  * @param {*} props
  * @see Form
  */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var TextAreaCounter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TextAreaCounter, _React$Component);
  function TextAreaCounter(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    /**
       * Handle change.
       *
       * @memberof TextAreaCounter
       */
    _this.handleChange = function (event, data) {
      var onChange = _this.props.onChange;
      _this.setState({
        characterCount: _.size(event.target.value),
        value: event.target.value
      });
      if (!_.isNil(onChange)) {
        onChange(event, data);
      }
    };
    /**
       * Handle reference width of label.
       *
       * @memberof TextAreaCounter
       */
    _this.handleRef = function (node) {
      var resizeObserver = new ResizeObserver(function (entries) {
        _.map(entries, function (entry) {
          if (entry.contentRect) {
            _this.setState({
              fieldWidth: entry.contentRect.width
            });
          }
        });
      });
      if (!_.isNil(node)) {
        resizeObserver.observe(node);
      }
    };
    /**
       *
       * @memberof TextAreaCounter
       */
    _this.renderCaracteresRestant = function () {
      var maxLength = _this.props.maxLength;
      var _this$state = _this.state,
        fieldWidth = _this$state.fieldWidth,
        characterCount = _this$state.characterCount,
        focused = _this$state.focused;
      var characterRemaining = maxLength - characterCount;
      var libelleRestant = characterRemaining > 1 ? "Caract\xE8res restants : " + characterRemaining : "Caract\xE8re restant : " + characterRemaining;
      return /*#__PURE__*/_jsx(Label, {
        horizontal: true,
        size: "mini",
        color: "grey",
        style: {
          position: 'absolute',
          right: 0,
          top: '100%',
          marginRight: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          opacity: 0.55
        },
        children: focused ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [fieldWidth < 90 && characterRemaining + "/" + maxLength, fieldWidth >= 90 && fieldWidth <= 175 && "Reste : " + characterRemaining, (fieldWidth > 175 || _.isNil(fieldWidth)) && libelleRestant]
        }) : characterRemaining + "/" + maxLength
      });
    };
    /**
       * Display the character counter
       *
       * @memberof TextAreaCounter
      */
    _this.handleFocus = function (event, data) {
      var onFocus = _this.props.onFocus;
      _this.setState({
        focused: true
      });
      if (onFocus) {
        onFocus(event, data);
      }
    };
    /**
       * Hide the character counter
       *
       * @memberof TextAreaCounter
      */
    _this.handleBlur = function (event, data) {
      var onBlur = _this.props.onBlur;
      _this.setState({
        focused: false
      });
      if (onBlur) {
        onBlur(event, data);
      }
    };
    var value = props.value;
    _this.state = {
      characterCount: !_.isNil(value) ? value.length : 0,
      value: value,
      prevValue: value,
      focused: false
    };
    return _this;
  }

  /**
     * @description
     *
     * @static
     * @memberof TextAreaCounter
     */
  TextAreaCounter.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, previousState) {
    var prevValue = previousState.prevValue;

    // Compare the incoming prop to previous prop
    var value = prevValue !== nextProps.value ? nextProps.value : previousState.value;
    return {
      // Store the previous props in state
      prevValue: nextProps.value,
      value: value,
      characterCount: !_.isNil(value) ? value.length : 0
    };
  };
  var _proto = TextAreaCounter.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof TextAreaCounter
     */
  _proto.render = function render() {
    var _this$props = this.props,
      resize = _this$props.resize,
      maxLength = _this$props.maxLength,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var _this$state2 = this.state,
      value = _this$state2.value,
      focused = _this$state2.focused,
      characterCount = _this$state2.characterCount;
    return /*#__PURE__*/_jsxs(Segment, {
      basic: true,
      style: {
        padding: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0
      },
      children: [/*#__PURE__*/_jsx(Ref, {
        innerRef: this.handleRef,
        children: /*#__PURE__*/_jsx(TextAreaSemantic, Object.assign({
          style: {
            resize: resize,
            borderBottomRightRadius: 0
          }
        }, rest, {
          maxLength: maxLength,
          onChange: this.handleChange,
          value: value,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }))
      }), !_.isNil(maxLength) && (focused || characterCount !== 0) && this.renderCaracteresRestant()]
    });
  };
  return TextAreaCounter;
}(React.Component);
TextAreaCounter.handledProps = ["as", "maxLength", "onBlur", "onChange", "onFocus", "onInput", "resize", "rows", "value"];
TextAreaCounter.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /**
     * Called on change.
     * @param {SyntheticEvent} event - The React SyntheticEvent object
     * @param {object} data - All props and the event value.
     */
  onChange: PropTypes.func,
  /** Callback on blur. */
  onBlur: PropTypes.func,
  /** Callback on focus. */
  onFocus: PropTypes.func,
  /**
     * Called on input.
     * @param {SyntheticEvent} event - The React SyntheticEvent object
     * @param {object} data - All props and the event value.
     */
  onInput: PropTypes.func,
  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resize: PropTypes.oneOf(['none', 'vertical', 'horizontal', 'both']),
  maxLength: PropTypes.number
};
TextAreaCounter.defaultProps = {
  as: 'textarea',
  rows: 3,
  resize: 'none'
};
export default TextAreaCounter;